






import * as echarts from "echarts";
import { defineComponent, onMounted, ref, watch, onBeforeUnmount, shallowRef } from "@vue/composition-api";
import { ChartType } from "../types";
import { debounce } from "@/common/util";
import { colorArray } from '../hooks/origin-data';
export default defineComponent({
    components: {},
    props: {
        data: {
            type: Object,
            default: () => {
                return {}
            }
        },
        chartSetting: {
            type: Object,
            default: () => {}
        },
        selected: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    setup(props, context) {
        const myChart = shallowRef();
        const showNoData = ref(false);


        const optionData = ref<any>({
            legend: {
                left: 'center',
                bottom: '0',
                itemWidth: 12,
                itemHeight: 5,
                icon: 'rect',
            },
            tooltip: {
                trigger: 'item'
            },
            series: [] as any,
        });
        const chartEl = ref(null);

        // 初始化图表
        function initChart() {
            myChart.value = echarts.init(chartEl.value);
            optionData.value && myChart.value.setOption(optionData.value);
        }

        // 屏幕适配
        function resizeHandler() {
            myChart.value && myChart.value.resize();
        }
        const cancalDebounce = debounce(resizeHandler, 50);
        // 处理series
        function seriesFunc(val: ChartType) {
            const value = {
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderColor: '#fff',
                    borderWidth: 1
                },
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: false,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: [] as {value: string, name: string}[]
            }

            // 整合饼图echarts数据
            const allRecords = {} as any;
            val.records.forEach((m: any, i: number) => {
                Object.keys(m).map(item => {
                    if(item !== 'p_date') {
                        if(i === 0) {
                            allRecords[item] = Number(m[item])
                        } else {
                            allRecords[item] += Number(m[item])
                        }
                        
                    }
                })
            })
            val.titles.forEach((item: any, i: number) => {
                if(item.fieldName !== 'p_date') {
                    const itemVal = {
                        name: item.displayName,
                        value: allRecords[item.fieldName] || '0',
                        itemStyle: {
                            color: colorArray[i]
                        }
                    }
                    value.data.push(itemVal)
                }
            })
            optionData.value.series = value;
        }

        onBeforeUnmount(() => {
            window.removeEventListener('resize', cancalDebounce);
            myChart.value && myChart.value.dispose();
        })

        // 初始化图表数据
        function init() {
            seriesFunc(props.data as ChartType);
        }

        onMounted(async () => {
            if(!props.data.records.length) {
                showNoData.value = true;
                return
            };
            if(props.data.titles.length === 1 && props.data.titles[0].fieldName === 'p_date') {
                showNoData.value = true;
                return
            }
            init();
            initChart();
            myChart.value.setOption(optionData.value);
            window.addEventListener('resize', cancalDebounce);
        });

        watch(
            () => props.data,
            () => {
                if(!props.data.records.length) {
                    showNoData.value = true;
                    return
                }
                if(props.data.titles.length === 1 && props.data.titles[0].fieldName === 'p_date') {
                    showNoData.value = true;
                    return
                }
                init();
                myChart.value.setOption(optionData.value);
            },
            {deep: true}
        )
        return {
            chartEl,
            showNoData,
        };
    },
});
